import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStatusInfoBoxStyles = makeStyles({
    statusMessageContainer: {
        ...shorthands.borderRadius(tokens.borderRadiusMedium),
        ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingVerticalM),
        ...shorthands.margin(tokens.spacingVerticalM, 'auto')
    },
    successfulStatus: {
        backgroundColor: tokens.colorPaletteGreenBackground1
    },
    failedStatus: {
        backgroundColor: tokens.colorPaletteRedBackground2
    },
    statusSymbol: {
        height: '32px',
        ...shorthands.margin('auto', '8px', 'auto', '0')
    },
    successfulSymbol: {
        color: tokens.colorPaletteGreenForeground2
    },
    failedSymbol: {
        color: tokens.colorPaletteRedForeground2
    },
    statusMessage: {
        width: '100%'
    }
});
